import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drag-next",
  "use": "icon-drag-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-drag-next\">\n<circle cx=\"10\" cy=\"8\" r=\"1\" fill=\"#B5BBC5\" />\n<circle cx=\"14\" cy=\"8\" r=\"1\" fill=\"#B5BBC5\" />\n<circle cx=\"10\" cy=\"12\" r=\"1\" fill=\"#B5BBC5\" />\n<circle cx=\"14\" cy=\"12\" r=\"1\" fill=\"#B5BBC5\" />\n<circle cx=\"10\" cy=\"16\" r=\"1\" fill=\"#B5BBC5\" />\n<circle cx=\"14\" cy=\"16\" r=\"1\" fill=\"#B5BBC5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol